import { ACTION } from '@cvent/react-analytics';
import { METRICS_DESTINATIONS } from '@cvent/sli-nextjs-metrics';

const attributes = [
  'id',
  'environmentName',
  'eventId',
  'attendeeId',
  'appVersion',
  'accountMappingId',
  'product',
  'url',
  'pathname',
  'sessionId',
  'vendor',
  'source',
  'browser',
  'os',
  'deviceId',
  'deviceType',
  'platform',
  'environment',
  'contactId',
  'locale',
  'eventName',
  'guest',
  'visibility',
  'error',
  'status',
  'criticalBufferingCount',
  'annoyingBufferingCount',
  'quickBufferingCount',
  'result',
  'type',
  'frontendDuration',
  'sessionDuration',
  'presentationDuration',
  'metricType'
];

export const livestreamLifecycle = {
  id: 'livestream_lifecycle',
  name: 'Livestream Lifecycle',
  type: ACTION,
  attributes,
  destinations: ['Mixpanel', METRICS_DESTINATIONS.DATA_DOG],
  objectIdAttribute: 'sessionId',
  activityType: 'session.livestream_lifecycle'
};
